import { type VariantProps, cva } from 'class-variance-authority'
export { default as Input } from './Input.vue'

export const inputVariants = cva('input', {
  variants: {
    variant: {
      default:
        'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
      formField:
        'h-[58px] placeholder:text-[#9ca3af] rounded-[8px] bg-dark-grey border border-solid focus:border-highlight px-3 py-4 text-base font-normal text-white',
      disabled:
        'h-[58px] text-text-inactive rounded-[8px] bg-dark-grey border border-solid px-3 py-4 text-base font-normal '
    }
  }
})

export type InputVariants = VariantProps<typeof inputVariants>
